<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-card class="elevation-2">
            <v-form @submit.prevent="reqPhoneNumbers">
              <v-toolbar color="primary">
                <v-toolbar-title>
                  <v-icon>add_call</v-icon>
                  Add a new line
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
<!--              error bar-->
              <v-layout row v-if="error">
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-layout>
              <v-card-text>
                <h3 class="font-weight-regular">Search for a suitable number</h3>
               <v-divider></v-divider>
                <v-text-field
                    class="mt-3"
                    prepend-icon="mdi-phone-check"
                    v-model="phoneNumberSearch"
                    :counter="10"
                    :rules="numberRules"
                    label="Search phonenumber"
                    placeholder="647..."
                    outlined
                    required
                    type="number"
                ></v-text-field>
                <h3 class="font-weight-regular">Locality</h3>
                <v-divider></v-divider>
                <country-flag class="mr-1" :country='country' size='normal'/>
                <country-select
                    class="mt-2 mb-2 subtitle-1"
                    v-model="country"
                    :country="country"
                    topCountry="US"
                    autocomplete
                    style="outline:1px solid; border-radius: 2px;"

                />
                <region-select
                    v-if="(country === 'US') || (country === 'CA')"
                    class="subtitle-1"
                    v-model="region"
                    :country="country"
                    :region="region"
                    style="outline:1px solid; border-radius: 2px;"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined type="submit" :disabled="loading" :loading="loading">
                  Find phonenumbers
                <span slot="loader">
                      <v-progress-circular
                          indeterminate
                          :size="25"
                          color="black"
                      ></v-progress-circular>
                </span>
              </v-btn>
            </v-card-actions>
            </v-form>

            <v-simple-table v-if="availablePhoneNumbers">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Phone Number
                  </th>
                  <th class="text-left">
                    Locality
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="item in availablePhoneNumbers"
                    :key="item.phoneNumber"
                    @click="phoneNumberPicked(item)"
                >
                  <td>{{ item.friendlyName }}</td>
                  <td>{{ item.locality }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog
        transition="dialog-top-transition"
        max-width="500"
        v-model="provisionNumberDialog"
    >
      <template>
        <v-card>
          <v-toolbar
              style="background:linear-gradient(135deg, #17ead9 0%,#6078ea 100%)"
              dark
          >
            <v-toolbar-title>
              <v-icon>numbers</v-icon>
              Number Available
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-4">
            <div class="text-h6 font-weight-light pt-3 pl-8"></div>
            <div class="text-h5 pl-8">{{pickedPhoneNumber.friendlyName}}</div>
            <div class="text-h6 font-weight-light pt-3 pl-8">Capabilities</div>
            <div class="text-h6 pl-8">
              <v-icon>phone</v-icon> Voice
              <v-icon>sms</v-icon> Text
              <v-icon>mms</v-icon> Media
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
                text
                @click="provisionNumberDialog = false">
              cancel
            </v-btn>
            <v-btn
                outlined
                @click="provisionPhoneNumber()"
            ><v-icon>shopping_cart_checkout</v-icon>Buy</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-main>
</template>

<script>
import { getFunctions, httpsCallable  } from 'firebase/functions';
export default {
  data: () => ({
    email: '',
    password: '',
    signUp: false,
    name: '',
    numberRules: [
      v => !!v || 'First part of number is required',
      v => (v && v.length <= 10) || 'First parts of number must be 3 digits max',
    ],
    phoneNumberSearch: '',
    availablePhoneNumbers: null,
    provisionNumberDialog: false,
    pickedPhoneNumber: '',
    country: 'CA',
    region: ''
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    subscription () {
      let subs = this.$store.getters.subscriptions
      return subs.find(sub => {
        return sub.id === 'flexlinePhoneNumber'
      })
    },
  },
  mounted() {
    this.$store.dispatch('setLoading', false)
  },
  methods: {
    reqPhoneNumbers () {
      this.$store.dispatch('setLoading', true)
      this.$store.dispatch('clearError')
      const functions = getFunctions()
      const twilioNumberSearch = httpsCallable(functions, 'twilioNumberSearch')
      let searchObj = {numbers: this.phoneNumberSearch, country: this.country}
      if ((this.country === 'US') || (this.country === 'CA')) {
        searchObj.region = this.region
      }
      // console.log(searchObj)
      return twilioNumberSearch(searchObj)
          .then(res => {
            if (res.data.availableNumbers.length !== 0) {
              this.availablePhoneNumbers = res.data.availableNumbers
              this.phoneNumberSearch =''
            } else {
              this.availablePhoneNumbers = null
              this.$store.dispatch('setError', {message: 'Shoot! No available phone numbers found..lets try again.'})
            }
            this.$store.dispatch('setLoading', false)
          })
          .catch(err => {
            console.log(err)
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch('setError', err)
          })

    },
    phoneNumberPicked (phoneNumber) {
      this.pickedPhoneNumber = phoneNumber
      this.provisionNumberDialog = true
      console.log(this.pickedPhoneNumber)
    },
    provisionPhoneNumber () {
      // let db = this.$store.state.db
      // let numberObj = {
      //   ...this.pickedPhoneNumber,
      //   paymentCheck: 'failed',
      //   status: {type: 'warning', message: 'Purchase approval is pending'}
      // }
      // console.log(this.subscription)
      //set transactionObj
      this.$store.dispatch('initBillingCardPayment', {...this.subscription, phoneNumber: this.pickedPhoneNumber})

      // return setDoc(doc(db, 'users', this.user.uid, 'provisionedNumbers', numberObj.phoneNumber), numberObj )
      // .then (() => {
      //   this.provisionNumberDialog = false
      //   this.$router.push('/managePhoneNumbers')
      // })
      // .catch(err => {
      //   this.$store.dispatch('setError', err)
      // })

    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

